module.exports = __webpack_public_path__ + "img/insurance-life-buoy.1755dce.webp";